import {
  Box,
  Button,
  Stack,
  Typography,
} from "@braintrust/braintrust-ui-components";
import {
  ArrowRightIcon,
  EarthIcon,
} from "@braintrust/braintrust-ui-components/Icons";
import { openChoosePayoutMethodModal } from "@js/apps/withdrawal/components/choose-payout-method-modal";
import { RouterLink } from "@js/components/link";
import { ModalInstance } from "@js/components/modal";

import styles from "./styles.module.scss";

export const openBankingFromNonSupportedLocationModal = () => {
  ModalInstance.open({
    children: <BankingFromNonSupportedLocationModalContent />,
    closeButton: true,
    className: styles.modal,
    padding: false,
    closeButtonProps: { variant: "gray-orange", sx: { svg: { m: 0 } } },
  });
};

export const BankingFromNonSupportedLocationModalContent = () => {
  const handleBrowseJobs = () => {
    ModalInstance.close();
  };

  const handleUpdateBanking = () => {
    ModalInstance.close();
    openChoosePayoutMethodModal();
  };

  return (
    <Box>
      <Stack className={styles.header} sx={{ p: { xs: 3, sm: 4, md: 5 } }}>
        <Box
          sx={{
            display: "grid",
            placeItems: "center",
            zIndex: 1,
            backgroundColor: "#fff",
            borderRadius: "1rem",
            width: "56px",
            height: "56px",
            mb: 2.25,
            boxShadow: "0px 4px 12px 0px #14141714",
          }}
        >
          <EarthIcon sx={{ color: "#AA6908", fontSize: 26 }} />
        </Box>

        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            display: "inline-flex",
            alignItems: "center",
            gap: "0.5rem",
            backgroundColor: "#fff",
            borderRadius: "50px",
            padding: "4px 16px",
            mb: 1.5,
            border: "1px solid #AA69082E",
          }}
        >
          <Typography
            component="span"
            variant="label"
            size="small"
            fontWeight={500}
            className="dot-prefix"
            sx={{
              fontSize: "11px !important",
              letterSpacing: "1.2px !important",
              textTransform: "uppercase",
              color: "#AA6908",
              "--dot-size": "6px",
            }}
          >
            Limited Access
          </Typography>
        </Box>

        <Typography
          component="h2"
          variant="title"
          size="small"
          fontWeight={500}
          sx={{
            maxWidth: "390px",
            mb: 2,
            fontSize: "28px !important",
            lineHeight: "36px !important",
          }}
        >
          It looks like your bank is in a country we can't pay into, so your job
          feed will be limited.
        </Typography>

        <Typography
          component="p"
          variant="paragraph"
          size="small"
          color="grey-1"
          sx={{ fontSize: "14px !important", maxWidth: "330px" }}
        >
          You'll see roles where we can process payment. You're welcome to set
          up different banking information to apply to the greater jobs list.
        </Typography>
      </Stack>

      <Stack
        sx={{ p: { xs: 2, sm: 3, md: 4 }, pb: { xs: 2, sm: 2.5, md: 3.5 } }}
      >
        <Typography
          component="p"
          variant="paragraph"
          size="medium"
          color="grey-1"
          sx={{
            textAlign: "center",
            mb: { xs: 2, sm: 3 },
            fontSize: "14px !important",
          }}
        >
          You can update your banking from your profile any time. We'll match
          you to roles based on your current banking country.
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
          <Typography
            variant="link"
            RouterLink={RouterLink}
            component="a"
            href="https://support.usebraintrust.com/hc/en-us/articles/41239692662807-Where-does-Braintrust-send-payments"
            fontWeight={500}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.25rem",
              color: "var(--dark-violet)",
              fontSize: "14px !important",
            }}
          >
            <ArrowRightIcon sx={{ fontSize: "inherit", color: "inherit" }} />
            See supported countries (FAQ)
          </Typography>
        </Box>

        <Stack direction="row" sx={{ justifyContent: "center", gap: 1.5 }}>
          <Button
            variant="white-violet"
            shape="squared"
            RouterLink={RouterLink}
            to="/jobs"
            component={RouterLink}
            onClick={handleBrowseJobs}
            sx={{ fontSize: "14px !important" }}
          >
            Browse available jobs
          </Button>
          <Button
            variant="dark-violet"
            shape="squared"
            onClick={handleUpdateBanking}
            endIcon={<ArrowRightIcon />}
            sx={{ fontSize: "14px !important" }}
          >
            Update banking
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};
